import React from 'react';

import icaseImage from '../../../Assets/Linkages/InternationalConferences/ICASE-Banner.jpeg';

const ICASEFeature = () => (
  <section className="international-conference-feature international-conference-feature--white" aria-labelledby="icase-feature-title">
    <div className="international-conference-feature-inner international-conference-feature-inner--reverse">
      <div className="international-conference-feature-copy">
        <p className="section-eyebrow">AEROSPACE SCIENCE · ENGINEERING · COLLABORATION</p>
        <h2 id="icase-feature-title">International Conference on Aerospace Science &amp; Engineering</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          International Conference on Aerospace Science &amp; Engineering (ICASE) is a regular biennial
          event providing an international forum where scientists, researchers, engineers, academicians,
          industry professionals, entrepreneurs, and students from around the world can interact and
          discuss the latest themes and trends in aerospace science and engineering.
        </p>
        <p>
          It provides a platform to share experiences, foster collaboration across industry and academia,
          and evaluate emerging technologies and developments in space science, technology, and applications.
          ICASE helps establish dialogues that lead to long-lasting technical cooperation among scientists
          and engineers from developing and developed countries.
        </p>
        <a className="outreach-film-trailer-link" href="https://ncgsa.org.pk/icase-2/" target="_blank" rel="noopener noreferrer">
          Read More <span aria-hidden="true">→</span>
        </a>
      </div>
      <figure className="international-conference-feature-image">
        <img src={icaseImage} alt="International Conference on Aerospace Science and Engineering" loading="lazy" />
      </figure>
    </div>
  </section>
);

export default ICASEFeature;
